import { api } from '@/lib/api-client';

export interface FailedDocument {
  id: string;
  filename: string;
  currentStep: string;
  holdReason: string | null;
  updatedAt: string;
  batchId: string;
  batchName: string;
  /** E-050 — displayId-led identity (customDisplayLabel ?? displayId ?? name). */
  batchLabel?: string;
}

export interface FailedDocumentsResponse {
  documents: FailedDocument[];
}

export interface RetryResponse {
  success: boolean;
  documentId: string;
}

export function list(): Promise<FailedDocumentsResponse> {
  return api.get<FailedDocumentsResponse>('/admin/failed-documents');
}

export function retry(documentId: string): Promise<RetryResponse> {
  return api.post<RetryResponse>(`/admin/failed-documents/${documentId}/retry`);
}
